const zhCN = {
  common: {
    openWpsExperience: '打开WPS Office体验',
    download: '下载',
    wpsOffice: 'WPS Office',
    claimNow: '立即领取',
  },
  page: {
    downloadTitle: 'WPS Office下载',
    companyName: '珠海金山办公软件有限公司',
  },
  tip: {
    upgradeForMore: '请升级至最新版本，体验更多功能',
    unsupportedOpenInApp: {
      weixin: {
        title: '在微信中无法打开APP',
        step1: '1. 请点击右上角按钮',
        step2: '2. 选择【在默认浏览器中打开】',
      },
      qq: {
        title: '在QQ中无法打开APP',
        step1: '1. 请点击右上角按钮',
        step2: '2. 选择【浏览器】',
      },
      weibo: {
        title: '在微博中无法打开APP',
        step1: '1. 请点击右上角按钮',
        step2: '2. 选择【在浏览器中打开】',
      },
    },
  },
  ability: {
    buttonTip: {
      developing: '该功能待开发',
      opening: '正在打开WPS Office',
      mobileOnly: '请在移动端WPS Office体验功能',
      androidOnly: '请在安卓端WPS Office体验功能',
      iosOnly: '请在IOS端WPS Office体验功能',
    },
  },
  template: {
    title: 'WPS Office',
    desc: '随时随地，让你办公更高效',
    featureIntro: '功能介绍',
    t001: {
      title: '输出为PDF',
      introduction: '将文档转成PDF格式',
      desc1: '将表格，演示，文字组件的文档转换成PDF文档',
      desc2: '转成PDF文档，便于保存，阅读与打印',
      desc3: '免费功能，任意使用',
    },
  },
};

export default zhCN;
